import Component from "../classes/Component"
import each from 'lodash/each'

import gsap from "gsap"

export default class Navlist extends Component {
    constructor({ element }) {
        super({ element })

        if(this.element){ this.createNavlist(this.element) }
    }

    createNavlist = (entry) => {
        let links = entry.querySelectorAll("a[data-gallery]")
        let target = {
            left: entry.querySelector("img.left"),
            right: entry.querySelector("img.right"),
        }
        
        if (links) {
            const gallery = new Array()
            const leftCurrentSrc = ''
            const rightCurrentSrc = ''

            each(links, (entry, index) => {
                gallery.push(JSON.parse(entry.getAttribute("data-gallery")))
                
                entry.onmouseenter = () => {
                    const left = gallery[index][0]
                    const right = gallery[index][1]
                    
                    if (left === leftCurrentSrc && right === rightCurrentSrc) { return }
                    
                    this.timeline = gsap.to(target, {
                        opacity: 0,
                        duration: 0.3,
                        onComplete: () => {
                            target.left.src = left
                            target.right.src = right
                            gsap.to(target, { 
                                opacity: 1, 
                                duration: 0.3 
                            })
                        }
                    })
                }
            })
        }
    }

    addEventListeners() {
    }
}